export type TypePageLegale = 'mentions' | 'cgu' | 'confidentialite'

/** Les trois pages légales, publiques. Dans un module à part pour que l'application n'embarque pas leur contenu. */
export const PAGES_LEGALES: { type: TypePageLegale; chemin: string; titre: string; court: string }[] = [
  { type: 'mentions', chemin: '/mentions-legales', titre: 'Mentions légales', court: 'Mentions légales' },
  { type: 'cgu', chemin: '/cgu', titre: 'Conditions générales d’utilisation et de vente', court: 'CGU / CGV' },
  { type: 'confidentialite', chemin: '/confidentialite', titre: 'Politique de confidentialité', court: 'Confidentialité' },
]

export const CHEMINS_LEGAUX: Record<string, TypePageLegale> = Object.fromEntries(PAGES_LEGALES.map((p) => [p.chemin, p.type]))
